module.exports = __webpack_public_path__ + "static/media/calendar.c6231306.svg";